import * as React from "react";
import Component from "../../../../AbstractComponent";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { Title } from "../../NewCoach/NewCoachComponents/Title";
import { Subtitle } from "../../NewCoach/NewCoachComponents/Subtitle";

export class NewChargeStep1 extends Component {
  render() {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.props.chargeType !== "payment" ? this.props.trans("coach/newcharge-step1/title") : this.props.trans("coach/newcharge-step1/title-payment", {amount: this.formatter.formatNumber(this.props.payment?.amountRemaining, this.props.payment?.currency)})}
          style={this.props.chargeType === "payment" && {marginBottom: "40px"}}
        />
        {this.props.chargeType !== "payment" &&
        <Subtitle
          subtitle={this.props.trans("coach/newcharge-step1/subtitle", {agencyName: this.props.agencyName})}
        />
        }
        <div>
          <div>
            <div
              className="filters-wrapper"
              style={{
                display: "flex",
                marginBottom: "10px"
              }}
            >
            <RadioGroup
              name="roleFilters"
              value={this.props.coachType}
              onChange={this.props.changeCoachType}
              style={{
              display: "flex",
              flexDirection: "column",
              margin: "auto"
              }}
            >
              {((this.props.payment && this.props.coachType === "Receivable") || !this.props.payment) && (
                <FormControlLabel
                  value={"Receivable"}
                  label={this.props.payment ? this.props.trans("coach/paymentcharge-step1/charge-to-be-received") : this.props.trans("to-be-received-from-owner")}
                  // style={radioButtonStyles}
                  control={<Radio color="primary" />}
                />
              )}
              {((this.props.payment && this.props.coachType === "Payable") || !this.props.payment) && (
                <FormControlLabel
                  value={"Payable"}
                  label={this.props.payment ? this.props.trans("coach/paymentcharge-step1/charge-to-be-paid") : this.props.trans("to-be-paid-to-owner")}
                  // style={radioButtonStyles}
                  control={<Radio color="primary" />}
                />
              )}
              {/* {!this.props.hasObjectChargeType && !this.props.payment && (
                <FormControlLabel
                  value={"registerIncomingInvoice"}
                  label={this.props.payment ? this.props.trans("coach/paymentcharge-step1/credit-charge") : this.props.trans("coach/newcharge-step1/option-registerincominginvoice")}
                  // style={radioButtonStyles}
                  control={<Radio color="primary" />}
                />
              )} */}
            </RadioGroup>
            </div>
          </div>
        </div>
      </div>
    )
  }
}